import React from 'react'

import styles from './Icon.module.scss'
import classNames from 'classnames'

const IconComponent = React.memo(function Icon(props) {
  const { name, appearance, size } = props
  const iconClasses = classNames(
    styles.wrapper,
    { [styles.light]: appearance === 'light' },
    { [styles.dark]: appearance === 'dark' },
    { [styles.greyDark]: appearance === 'greyDark' },
    { [styles.grey]: appearance === 'grey' },
    { [styles.greyLight]: appearance === 'greyLight' },
    { [styles.link]: appearance === 'link' },
    { [styles.brand]: appearance === 'brand' },
    { [styles.warning]: appearance === 'warning' },
    { [styles.error]: appearance === 'error' },
    { [styles.success]: appearance === 'success' },
    { [styles.small]: size === 'small' },
    { [styles.medium]: size === 'medium' },
    { [styles.large]: size === 'large' },
    { [styles.xlarge]: size === 'xlarge' }
  )

  const svg = require(`!raw-loader!../../../assets/svg/${name}.svg`)
  return (
    <i
      aria-hidden="true"
      className={iconClasses}
      data-cy={`${name}Icon`}
      dangerouslySetInnerHTML={{ __html: svg.default }}
    />
  )
})

export default IconComponent
